import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { env, Loader, useScript } from '@neo.tax/shared';
import { fileUploadsVar, removeFileUpload } from '@neo.tax/shared/state/fileUploadsVar';
import { isLocalEnvironment } from '@neo.tax/shared/utils/environment.utils';

import { useBaseRedirect } from './hooks';

export const Base = (): React.ReactElement => {
  useEffect(() => {
    // the browser will not wait for a promise to resolve before navigating away, so we need to use the
    // sendBeacon API to ensure that the request is sent before the page is unloaded
    const handleBeforeUnload = (_event: Event): void => {
      // Stop any file uploads in progress
      const fileUploads = fileUploadsVar();
      for (const fileUpload of fileUploads.values()) {
        removeFileUpload(fileUpload.file.name);
        if (fileUpload.cloudStorageLocationUrl) {
          navigator.sendBeacon(
            env.REACT_APP_BACKEND_BASE_URL + '/uploads/cancel-resumable-upload',
            JSON.stringify({ locationUrl: fileUpload.cloudStorageLocationUrl }),
          );
        }
      }
    };

    // Triggered when the user is leaving the page, such as refreshing or closing the tab
    window.addEventListener('beforeunload', handleBeforeUnload);

    return (): void => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useScript({
    src: '//code.tidio.co/oottndvo5pm9khcowml82xts5rquxeig.js',
    loadedName: 'Tidio',
    shouldLoad: !isLocalEnvironment(),
  });

  return (
    <Loader useRedirect={useBaseRedirect}>
      <Outlet />
    </Loader>
  );
};
